import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import CargoTypeListToggler from '../../../cargoType/CargoTypeListToggler';
import { ActionPropTypes } from '../../../layout/Datagrid';
import { ListPageWithPersisted, navigateTo } from '../../../layout/ListPage';
import { ListPageHeaderWithSearch } from '../../../layout/ListPage/headers';
import BulkListActions from './BulkListActions';
import getColumns from './columns';
import ItemsAdvancedFilterSection from './ItemsAdvancedFilterSection';
import useGetBulkListPills from './useGetBulkListPills';
import useGetItems from './useGetItems';
import useGetOptions from './useGetOptions';

const BulkItemListPage = ({ actions }) => {
  const [fetchItems, data = {}] = useGetItems();
  const [
    getOptions,
    options = {
      clientInventories: [],
      productTypes: [],
      productSubtypes: [],
      sites: [],
    },
  ] = useGetOptions();
  const { t } = useTranslation('inventory');
  const { push } = useHistory();
  const location = useLocation();

  const columns = useMemo(() => {
    const fromString = (str) => ({ key: str, value: str, label: str });
    const mappedOptions = {
      clientInventories: options.clientInventories.map(fromString),
      productTypes: options.productTypes.map(fromString),
      productSubtypes: options.productSubtypes.map(fromString),
      sites: options.sites.map(fromString),
    };

    return getColumns(mappedOptions);
  }, [options]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => getOptions(), []);

  useEffect(() => {
    const listType = localStorage.getItem('listType');
    if (listType || location.search !== '' || !Array.isArray(data?.items)) return;
    if (data.items.length > 0) {
      localStorage.setItem('listType', 'bulk');
    }
  }, [data, location.search]);

  return (
    <>
      <ListPageWithPersisted
        header={ListPageHeaderWithSearch}
        title={t('inventory')}
        fetcher={fetchItems}
        data={data}
        columns={columns}
        withPresets
        translater={t}
        onRowClick={navigateTo((row) => `/inventory/${row.clientInventory.id}/items/${row.id}`, push)}
        pills={useGetBulkListPills(data, t)}
        actions={actions}
        headerProps={{
          actions: <BulkListActions totalCount={data?.totalItems} />,
          advancedFilterSection: ItemsAdvancedFilterSection,
          subscript: <CargoTypeListToggler />,
        }}
      />
    </>
  );
};

BulkItemListPage.propTypes = {
  actions: PropTypes.arrayOf(ActionPropTypes),
};

BulkItemListPage.defaultProps = {
  actions: [],
};

export default BulkItemListPage;
